<template>
  <div />
</template>

<script>
import confettiModule from 'canvas-confetti'

const ANGLE_MAP = {
  0: 110,
  1: 70,
  2: 110,
}

const X_ORIGIN_MAP = {
  0: 0.9,
  1: 0.1,
  2: 0.9,
}

export default {
  name: 'RiddleConfetti',
  data() {
    return {
      interval: null,
      launches: 0,
      maxLaunches: 3,
    }
  },
  methods: {
    getOptions() {
      return {
        angle: ANGLE_MAP[this.launches],
        origin: {
          x: X_ORIGIN_MAP[this.launches],
          y: 0.95,
        },
        colors: ['209880', 'EBA547'],
        shapes: ['square'],
        scalar: 1.1,
        startVelocity: 50,
      }
    },
    launchConfetti() {
      confettiModule(this.getOptions())
      this.launches += 1
    },
    async play() {
      await new Promise((resolve) => {
        this.launchConfetti()

        this.interval = setInterval(() => {
          if (this.launches < this.maxLaunches) {
            this.launchConfetti()
            return true
          }

          clearInterval(this.interval)
          resolve()
        }, 500)
      })

      await new Promise((r) => setTimeout(r, 1200))

      this.$emit('animation-completed')
    },
  },
  mounted() {
    this.play()
  },
  emits: ['animation-completed'],
}
</script>
